import { render, staticRenderFns } from "./worklistManaging.vue?vue&type=template&id=1f8f8dc3&scoped=true&"
import script from "./worklistManaging.vue?vue&type=script&lang=js&"
export * from "./worklistManaging.vue?vue&type=script&lang=js&"
import style0 from "./worklistManaging.vue?vue&type=style&index=0&id=1f8f8dc3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f8dc3",
  null
  
)

component.options.__file = "worklistManaging.vue"
export default component.exports